import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTreatment, setSelectedTreatment] = useState(null);
  const [bookingData, setBookingData] = useState({
    treatments: [],
    date: '',
    time: '',
    duration: 60,
    customerInfo: {
      name: '',
      email: '',
      phone: '',
      isFirstTime: false,
      specialRequests: ''
    }
  });

  const openBookingModal = (treatment = null) => {
    if (treatment) {
      setSelectedTreatment(treatment);
      setBookingData(prev => ({
        ...prev,
        treatments: [treatment]
      }));
    }
    setIsModalOpen(true);
  };

  const closeBookingModal = () => {
    setIsModalOpen(false);
    // Reset after a short delay to allow for exit animation
    setTimeout(() => {
      setSelectedTreatment(null);
      setBookingData({
        treatments: [],
        date: '',
        time: '',
        duration: 60,
        customerInfo: {
          name: '',
          email: '',
          phone: '',
          isFirstTime: false,
          specialRequests: ''
        }
      });
    }, 300);
  };

  const updateBookingData = (updates) => {
    setBookingData(prev => ({ ...prev, ...updates }));
  };

  const updateCustomerInfo = (updates) => {
    setBookingData(prev => ({
      ...prev,
      customerInfo: { ...prev.customerInfo, ...updates }
    }));
  };

  const addTreatment = (treatment) => {
    setBookingData(prev => ({
      ...prev,
      treatments: [...prev.treatments, treatment]
    }));
  };

  const removeTreatment = (treatmentId) => {
    setBookingData(prev => ({
      ...prev,
      treatments: prev.treatments.filter(t => t.id !== treatmentId)
    }));
  };

  const value = {
    isModalOpen,
    selectedTreatment,
    bookingData,
    openBookingModal,
    closeBookingModal,
    updateBookingData,
    updateCustomerInfo,
    addTreatment,
    removeTreatment
  };

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};

export default BookingContext; 
